import React from "react"
import './header-card.scss'

interface HeaderCardProps {
    number: number;
    text: string;
    backgroundColor?: string;
    textColor?: string;
}

export function HeaderCard(props: HeaderCardProps) {
    return (
      <div className="header-card" style={{ backgroundColor: props.backgroundColor, color: props.textColor }}>
        <div className="header-card-number">{props.number}</div>
        <div className="header-card-text">{props.text}</div>
      </div>
    );
  }
